import { render } from "./AppStoreButton.vue?vue&type=template&id=224a7b5e&scoped=true&ts=true"
import script from "./AppStoreButton.vue?vue&type=script&lang=ts"
export * from "./AppStoreButton.vue?vue&type=script&lang=ts"

import "./AppStoreButton.vue?vue&type=style&index=0&id=224a7b5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224a7b5e"]])

export default __exports__